import { Link } from "react-router-dom";
import { GraduationCap, Handshake, Scale, Gift, ArrowRight } from "lucide-react";

const CARDS = [
  {
    icon: GraduationCap,
    audience: "For Students & Visa Applicants",
    title: "Study or Migrate to Australia or New Zealand",
    desc: "Personalised course, institution and visa pathway recommendations across Australia and New Zealand — tailored to your education, experience and goals.",
    cta: "Start My Assessment",
    to: "/pathway-assessment",
    testid: "pathway-card-study",
  },
  {
    icon: Handshake,
    audience: "For Education Agents",
    title: "I Am an Education Agent",
    desc: "Partner with us for licensed migration support, access to Australian and New Zealand institutions, and seamless student referrals.",
    cta: "Become a Partner",
    to: "/education-agent-partnership",
    testid: "pathway-card-agent",
  },
  {
    icon: Scale,
    audience: "For Migration Agents & Advisers",
    title: "I Am a Migration Agent or Adviser",
    desc: "Join our professional network for quality client referrals and trans-Tasman collaboration across Australia and New Zealand.",
    cta: "Join the Network",
    to: "/rma-network",
    testid: "pathway-card-rma",
  },
  {
    icon: Gift,
    audience: "For Friends, Family & Community",
    title: "Refer Someone & Get Rewarded",
    desc: "Know someone planning to study, migrate or visit Australia or New Zealand? Refer them and get rewarded when they become our client.",
    cta: "Refer Now",
    to: "/refer",
    testid: "pathway-card-refer",
  },
];

export default function SmartPathways() {
  return (
    <section data-testid="smart-pathways-section" className="py-10 md:py-14 bg-white relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center mb-8 md:mb-10">
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.05] text-[#29324A]">
            Your Australia &amp; New Zealand Journey{" "}
            <span className="relative inline-block text-[#29324A]">
              Starts Here
              <span aria-hidden className="absolute -bottom-1 left-0 right-0 h-1.5 bg-[#C43A89]/25" />
            </span>
          </h2>
          <p className="mt-4 text-sm md:text-[15px] text-slate-600 leading-relaxed">
            Whether your future lies in Australia or New Zealand, you&apos;ll receive licensed, professional guidance for both countries. Choose the option that best describes you.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {CARDS.map(({ icon: Icon, audience, title, desc, cta, to, testid }) => (
            <Link
              key={testid}
              to={to}
              data-testid={testid}
              className="group relative bg-gradient-to-br from-[#29324A] via-[#1B1430] to-[#29324A] text-white shadow-lg shadow-[#29324A]/15 hover:shadow-2xl hover:shadow-[#C43A89]/25 hover:-translate-y-1.5 transition-all duration-300 flex flex-col overflow-hidden"
            >
              {/* WHO IT'S FOR — bold audience band */}
              <div className="flex items-center gap-2.5 bg-[#C43A89] px-5 py-3">
                <Icon className="h-4.5 w-4.5 text-white shrink-0" style={{ height: 18, width: 18 }} />
                <span className="text-[11px] font-bold tracking-[0.14em] uppercase leading-tight">{audience}</span>
              </div>
              <span aria-hidden className="absolute -top-10 -right-10 h-32 w-32 rounded-full bg-[#C43A89]/25 blur-2xl" />
              <div className="relative p-6 md:p-7 flex flex-col flex-1">
                <h3 className="font-display text-[22px] leading-tight">{title}</h3>
                <p className="text-[13.5px] text-slate-300 leading-relaxed mt-3 flex-1">{desc}</p>
                <span className="mt-6 inline-flex items-center justify-center gap-2 bg-white text-[#29324A] group-hover:bg-[#C43A89] group-hover:text-white text-[11.5px] font-bold tracking-[0.16em] uppercase px-4 py-3.5 transition-colors">
                  {cta} <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
